import {Box, Button, Stack} from "@mui/material";
import MobileMenu from "./MobileMenu";
import {STYLE} from "../STYLES";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, RootState} from "../../../store/store";
import {openLoginDialog} from "../../../store/actions/loginDialogSlice";

export default function Navbar() {
  const {isMobile} = useSelector((state: RootState) => state.deviceDetails);

  return isMobile ? <MobileMenu /> : <NavbarDesktop />;
}

function NavbarDesktop() {
  const dispatch = useDispatch<AppDispatch>();

  const onNavbarLoginButtonClick = () => {
    dispatch(openLoginDialog());
  };

  const onNavbarSignUpButtonClick = () => {
    dispatch(openLoginDialog());
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 3,
        position: "sticky",
        top: 16,
        backgroundColor: "#FFFFFF80",
        zIndex: 10,
        backdropFilter: "blur(100px)",
        px: 2,
        py: 1.5,
        borderRadius: "12px",
      }}>
      <Stack direction="row">
        <Box
          component="img"
          src="/PrepGenieLogo.svg"
          alt="PrepGenie Logo"
          sx={{height: {xs: "24px", md: "30px"}}}
        />
        <Box width={110} />
      </Stack>
      <Stack direction="row" spacing={2}>
        <Button variant="text" sx={STYLE.navbarButton}>
          Features
        </Button>
        <Button variant="text" sx={STYLE.navbarButton}>
          Exams
        </Button>
        <Button variant="text" sx={STYLE.navbarButton}>
          Help
        </Button>
        <Button variant="text" sx={STYLE.navbarButton}>
          Pricing
        </Button>
      </Stack>
      <Stack direction="row" spacing={1}>
        <Button
          variant="text"
          sx={STYLE.navbarLoginButton}
          onClick={onNavbarLoginButtonClick}>
          Log in
        </Button>
        <Button
          variant="contained"
          sx={STYLE.navbarSignUpButton}
          onClick={onNavbarSignUpButtonClick}>
          Create account
        </Button>
      </Stack>
    </Box>
  );
}
